import { createAction, handleActions } from "redux-actions";
import {
  _getActiveServiceTypesList,
  _getActivePetTypesList,
  _addNewVenue,
  _getPetSizesList,
  _venueById,
  _editVenue,
  _getEtailStoreList,
  _getEtailStoreDetails,
  _deleteVenue,
} from "~shared/httpService/apis";
import ActionTypes from "~shared/constants/actionTypes";
import { _getServiceTypeByPagination } from "../../../shared/httpService/apis";

const initialState = {
  service_types: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  pet_types_list: { loading: false, response: [], hasError: false, error: {} },
  add_new_venue: {
    loading: false,
    response: {},
    hasError: false,
    error: {},
  },
  pet_size_list: { loading: false, response: [], hasError: false, error: {} },
  pet_nature_list: { loading: false, response: [], hasError: false, error: {} },
  venue_info: {
    loading: false,
    response: {},
    hasError: false,
    error: {},
  },
  edit_venue: {
    loading: false,
    response: {},
    hasError: false,
    error: {},
  },
  store_info: { loading: false, response: [], hasError: false, error: {} },
  store_by_id: { loading: false, response: [], hasError: false, error: {} },
  delete_venue: { loading: false, response: {}, hasError: false, error: {} },
};

export const getServiceTypesStart = createAction(
  ActionTypes.GET_SERVICE_TYPES_LIST
);
export const getServiceTypesSuccess = createAction(
  ActionTypes.GET_SERVICE_TYPES_LIST_SUCCESS,
  (response) => response
);
export const getServiceTypesError = createAction(
  ActionTypes.GET_SERVICE_TYPES_LIST_ERROR,
  (error) => error
);

export const getServiceTypesList =
  (page="",pageSize="",inputValue) =>
  (dispatch) => {
    dispatch(getServiceTypesStart());
    return _getServiceTypeByPagination(page,pageSize,inputValue)
      .then((response) => {
        dispatch(getServiceTypesSuccess(response));
      })
      .catch((error) => {
        dispatch(getServiceTypesError(error));
      });
  };

export const getActivePetTypesStart = createAction(
  ActionTypes.GET_ACTIVE_PET_LIST
);
export const getActivePetTypesSuccess = createAction(
  ActionTypes.GET_ACTIVE_PET_LIST_SUCCESS,
  (response) => response
);
export const getActivePetTypesError = createAction(
  ActionTypes.GET_ACTIVE_PET_LIST_ERROR,
  (error) => error
);

export const getActivePetTypesList = (page = '', pageSize) => (dispatch) => {
  dispatch(getActivePetTypesStart());
  return _getActivePetTypesList(page, pageSize)
    .then((response) => {
      dispatch(getActivePetTypesSuccess(response));
    })
    .catch((error) => {
      dispatch(getActivePetTypesError(error));
    });
};

export const getPetSizeListStart = createAction(
  ActionTypes.GET_GENERAL_PET_SIZE
);
export const getPetSizeListSuccess = createAction(
  ActionTypes.GET_GENERAL_PET_SIZE_SUCCESS,
  (response) => response
);
export const getPetSizeListError = createAction(
  ActionTypes.GET_GENERAL_PET_SIZE_ERROR,
  (error) => error
);

export const getPetSizeList = (petId) => (dispatch) => {
  dispatch(getPetSizeListStart());
  return _getPetSizesList(petId)
    .then((response) => {
      dispatch(getPetSizeListSuccess(response));
    })
    .catch((error) => {
      dispatch(getPetSizeListError(error));
    });
};

export const addNewVenueStart = createAction(ActionTypes.ADD_VENUE);
export const addNewVenueSuccess = createAction(
  ActionTypes.ADD_VENUE_SUCCESS,
  (response) => response
);
export const addNewVenueError = createAction(
  ActionTypes.ADD_VENUE_ERROR,
  (error) => error
);

export const addNewVenue = (data) => (dispatch) => {
  dispatch(addNewVenueStart());
  return _addNewVenue(data)
    .then((response) => {
      dispatch(addNewVenueSuccess(response));
    })
    .catch((error) => {
      dispatch(addNewVenueError(error));
    });
};

export const getVenueByIDStart = createAction(ActionTypes.VENUE_BY_ID);
export const getVenueByIDSuccess = createAction(
  ActionTypes.VENUE_BY_ID_SUCCESS,
  (response) => response
);
export const getVenueByIDError = createAction(
  ActionTypes.VENUE_BY_ID_ERROR,
  (error) => error
);

export const getVenueByID = (id) => (dispatch) => {
  dispatch(getVenueByIDStart());
  return _venueById(id)
    .then((response) => {
      dispatch(getVenueByIDSuccess(response));
    })
    .catch((error) => {
      dispatch(getVenueByIDError(error));
    });
};

export const editVenueStart = createAction(ActionTypes.EDIT_VENUE);
export const editVenueSuccess = createAction(
  ActionTypes.EDIT_VENUE_SUCCESS,
  (response) => response
);
export const editVenueError = createAction(
  ActionTypes.EDIT_VENUE_ERROR,
  (error) => error
);

export const editVenue = (id, data) => (dispatch) => {
  dispatch(editVenueStart());
  return _editVenue(id, data)
    .then((response) => {
      dispatch(editVenueSuccess(response));
    })
    .catch((error) => {
      dispatch(editVenueError(error));
    });
};

export const getStoresStart = createAction(ActionTypes.GET_STORE_LIST);
export const getStoresSuccess = createAction(
  ActionTypes.GET_STORE_LIST_SUCCESS,
  (response) => response
);
export const getStoresError = createAction(
  ActionTypes.GET_STORE_LIST_ERROR,
  (error) => error
);

export const getStores = (schemaName, searchValue) => (dispatch) => {
  dispatch(getStoresStart());
  return _getEtailStoreList(schemaName, searchValue)
    .then((response) => {
      dispatch(getStoresSuccess(response));
    })
    .catch((error) => {
      dispatch(getStoresError(error));
    });
};

export const getStoreByIdStart = createAction(ActionTypes.GET_STORE_BY_ID_LIST);
export const getStoreByIdSuccess = createAction(
  ActionTypes.GET_STORE_BY_ID_LIST_SUCCESS,
  (response) => response
);
export const getStoreByIdError = createAction(
  ActionTypes.GET_STORE_BY_ID_LIST_ERROR,
  (error) => error
);

export const getStoreById = (id, schemaName) => (dispatch) => {
  dispatch(getStoreByIdStart());
  return _getEtailStoreDetails(schemaName, id)
    .then((response) => {
      dispatch(getStoreByIdSuccess(response));
    })
    .catch((error) => {
      dispatch(getStoreByIdError(error));
    });
};

export const deleteVenueStart = createAction(ActionTypes.DELETE_VENUE);
export const deleteVenueSuccess = createAction(
  ActionTypes.DELETE_VENUE_SUCCESS,
  (response) => response
);
export const deleteVenueError = createAction(
  ActionTypes.DELETE_VENUE_ERROR,
  (error) => error
);

export const deleteVenue = (id) => (dispatch) => {
  dispatch(deleteVenueStart());
  return _deleteVenue(id)
    .then((response) => {
      dispatch(deleteVenueSuccess(response));
    })
    .catch((error) => {
      dispatch(deleteVenueError(error));
    });
};

const reducer = handleActions(
  {
    //GET_SERVICE_TYPE
    [ActionTypes.GET_SERVICE_TYPES_LIST]: (state) => ({
      ...state,
      service_types: {
        ...state.service_types,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_SERVICE_TYPES_LIST_SUCCESS]: (state, action) => ({
      ...state,
      service_types: {
        ...state.service_types,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_SERVICE_TYPES_LIST_ERROR]: (state, action) => ({
      ...state,
      service_types: {
        ...state.service_types,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),

    //ACTIVE_PET_TYPES_LIST
    [ActionTypes.GET_ACTIVE_PET_LIST]: (state) => ({
      ...state,
      pet_types_list: {
        ...state.pet_types_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_PET_LIST_SUCCESS]: (state, action) => ({
      ...state,
      pet_types_list: {
        ...state.pet_types_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ACTIVE_PET_LIST_ERROR]: (state, action) => ({
      ...state,
      pet_types_list: {
        ...state.pet_types_list,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),

    //PET_SIZE_LIST
    [ActionTypes.GET_GENERAL_PET_SIZE]: (state) => ({
      ...state,
      pet_size_list: {
        ...state.pet_size_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_GENERAL_PET_SIZE_SUCCESS]: (state, action) => ({
      ...state,
      pet_size_list: {
        ...state.pet_size_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_GENERAL_PET_SIZE_ERROR]: (state, action) => ({
      ...state,
      pet_size_list: {
        ...state.pet_size_list,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),
    //PET_NATURE_LIST
    [ActionTypes.GET_PET_NATURE]: (state) => ({
      ...state,
      pet_nature_list: {
        ...state.pet_nature_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PET_NATURE_SUCCESS]: (state, action) => ({
      ...state,
      pet_nature_list: {
        ...state.pet_nature_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PET_NATURE_ERROR]: (state, action) => ({
      ...state,
      pet_nature_list: {
        ...state.pet_nature_list,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),
    //ADD_VENUE
    [ActionTypes.ADD_VENUE]: (state) => ({
      ...state,
      add_new_venue: {
        ...state.add_new_venue,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.ADD_VENUE_SUCCESS]: (state, action) => ({
      ...state,
      add_new_venue: {
        ...state.add_new_venue,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.ADD_VENUE_ERROR]: (state, action) => ({
      ...state,
      add_new_venue: {
        ...state.add_new_venue,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    // VENUE_BY_ID
    [ActionTypes.VENUE_BY_ID]: (state) => ({
      ...state,
      venue_info: {
        ...state.venue_info,
        loading: true,
        hasError: false,
        error: {},
        response: {},
      },
    }),
    [ActionTypes.VENUE_BY_ID_SUCCESS]: (state, action) => ({
      ...state,
      venue_info: {
        ...state.venue_info,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.VENUE_BY_ID_ERROR]: (state, action) => ({
      ...state,
      venue_info: {
        ...state.venue_info,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //EDIT_VENUE
    [ActionTypes.EDIT_VENUE]: (state) => ({
      ...state,
      edit_venue: {
        ...state.edit_venue,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.EDIT_VENUE_SUCCESS]: (state, action) => ({
      ...state,
      edit_venue: {
        ...state.edit_venue,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.EDIT_VENUE_ERROR]: (state, action) => ({
      ...state,
      edit_venue: {
        ...state.edit_venue,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //GET_STORE_LIST
    [ActionTypes.GET_STORE_LIST]: (state) => ({
      ...state,
      store_info: {
        ...state.store_info,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_STORE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      store_info: {
        ...state.store_info,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_STORE_LIST_ERROR]: (state, action) => ({
      ...state,
      store_info: {
        ...state.store_info,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),

    //GET_STORE_BY_ID_LIST
    [ActionTypes.GET_STORE_BY_ID_LIST]: (state) => ({
      ...state,
      store_by_id: {
        ...state.store_by_id,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_STORE_BY_ID_LIST_SUCCESS]: (state, action) => ({
      ...state,
      store_by_id: {
        ...state.store_by_id,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_STORE_BY_ID_LIST_ERROR]: (state, action) => ({
      ...state,
      store_by_id: {
        ...state.store_by_id,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),

    //DELETE_VENUE
    [ActionTypes.DELETE_VENUE]: (state) => ({
      ...state,
      delete_venue: {
        ...state.delete_venue,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.DELETE_VENUE_SUCCESS]: (state, action) => ({
      ...state,
      delete_venue: {
        ...state.delete_venue,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.DELETE_VENUE_ERROR]: (state, action) => ({
      ...state,
      delete_venue: {
        ...state.delete_venue,
        error: action.payload,
        loading: false,
        hasError: false,
        response: {},
      },
    }),
  },
  initialState
);

export default reducer;
